import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PlannerRoutingModule } from './planner-routing.module';
import { PlannerComponent } from './planner/planner.component';
import { FormsModule } from '@angular/forms';
import { NgbModalModule, NgbDatepickerModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { DateTimePickerComponent } from './planner/date-time-picker.component';


@NgModule({
  declarations: [
    PlannerComponent,
    DateTimePickerComponent
  ],
  imports: [
    CommonModule,
    PlannerRoutingModule,
    CommonModule,
    CalendarModule.forRoot({
        provide: DateAdapter,
        useFactory: adapterFactory
      }),
    NgbModalModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    FormsModule
  ]
})
export class PlannerModule { }
